import { SituacaoUpload, TipoDocumentoProfessorCertificacao } from 'src/tipos'

import { UploadDocumentos } from '../tipos'

export const RelacaoDocumentosProfessorCertificacao = new Array<UploadDocumentos>(
  {
    id: 1,
    tipo: TipoDocumentoProfessorCertificacao.Rg,
    status: SituacaoUpload.PendenteEnvio,
    ordemExibicao: 1,
    obrigatorio: true,
    editarAprovado: true
  },
  {
    id: 2,
    tipo: TipoDocumentoProfessorCertificacao.RgVerso,
    status: SituacaoUpload.PendenteEnvio,
    ordemExibicao: 2,
    obrigatorio: true,
    editarAprovado: true
  },
  {
    id: 3,
    tipo: TipoDocumentoProfessorCertificacao.DiplomaGraduacao,
    status: SituacaoUpload.PendenteEnvio,
    ordemExibicao: 2,
    obrigatorio: true,
    editarAprovado: true
  },
  {
    id: 4,
    tipo: TipoDocumentoProfessorCertificacao.DiplomaGraduacaoVerso,
    status: SituacaoUpload.PendenteEnvio,
    ordemExibicao: 2,
    obrigatorio: true,
    editarAprovado: true
  },
  {
    id: 5,
    tipo: TipoDocumentoProfessorCertificacao.DiplomaTitulacaoMaxima,
    status: SituacaoUpload.PendenteEnvio,
    ordemExibicao: 2,
    obrigatorio: true,
    editarAprovado: true
  },
  {
    id: 6,
    tipo: TipoDocumentoProfessorCertificacao.DiplomaTitulacaoMaximaVerso,
    status: SituacaoUpload.PendenteEnvio,
    ordemExibicao: 2,
    obrigatorio: true,
    editarAprovado: true
  } as UploadDocumentos
)
